import { Component } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-redirect',
  template: '',
})
export class RedirectComponent {}
